import script from "./VApprovementList.vue?vue&type=script&setup=true&lang=ts"
export * from "./VApprovementList.vue?vue&type=script&setup=true&lang=ts"

import "./VApprovementList.vue?vue&type=style&index=0&id=2e0cfefc&lang=scss"

const __exports__ = script;

export default __exports__